import { jsx as _jsx } from "react/jsx-runtime";
import { CookieConsentLoader, useCookieConsent } from '../../contexts';
import CookieConsentBody from './CookieConsentBody';
const CookieConsent = (props) => {
    const { storageName } = useCookieConsent();
    const Inner = () => {
        const { accepted } = useCookieConsent();
        return accepted ? null : (_jsx(CookieConsentBody, Object.assign({ background: true, paper: true, position: "fixed", bottom: 0, width: "100vw", zIndex: 1000 }, props), void 0));
    };
    //if not inside a context, make a context
    if (!storageName) {
        return (_jsx(CookieConsentLoader, { children: _jsx(Inner, {}, void 0) }, void 0));
    }
    return _jsx(Inner, {}, void 0);
};
export default CookieConsent;
//# sourceMappingURL=CookieConsent.js.map